import React, { CSSProperties } from 'react';
import styled, { ThemeProps } from 'styled-components';
import { Card } from 'styleguide/Card';
import { colors } from 'styleguide/colors';
import { Spacing } from 'styleguide/spacing';
import { TextSMRegular } from 'styleguide/Texts';
import { ThemedIcon, ThemedIconType } from 'styleguide/ThemedIcon';
import { Theme } from 'styleguide/types';

const Container = styled(Card)`
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'dark' ? colors.darkmodeNeutral100 : colors.white};
`;

const IconContainer = styled.div`
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface ChicletIndicatorProps {
  iconType: 'set' | 'reps' | 'timer';
  title?: string | number;
  style?: CSSProperties;
}

interface BaseThemeIconProps {
  type: ThemedIconType;
}

export const ChicletIndicator = ({ iconType, title, style }: ChicletIndicatorProps) => {
  const BaseThemeIcon = ({ type }: BaseThemeIconProps) => (
    <IconContainer>
      <ThemedIcon type={type} dark={colors.white} light={colors.black} />
    </IconContainer>
  );

  return (
    <Container style={{ flexDirection: 'row', alignItems: 'center', ...style }}>
      {iconType === 'set' && <BaseThemeIcon type="sets" />}
      {iconType === 'reps' && <BaseThemeIcon type="reps" />}
      {iconType === 'timer' && <BaseThemeIcon type="timer" />}
      <TextSMRegular type="secondary" style={{ marginRight: Spacing.sm }}>
        {title}
      </TextSMRegular>
    </Container>
  );
};
